import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bowser from 'bowser';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getUrlSecretId } from '@ifeng-fe/container_content/common/client/utils/utils';
import styles from './index.css';
import RecVideos from './recVideos';
import HotComment from './hotComment';
// import HotThemeList from './hotThemeList';
import { getSpecificList, getRelateFeedList } from '../../../../services/api';
import { transformArr } from '../../../../utils/utils';

/**
 * 定义 content 组件
 */
class Content extends PureComponent {
    static propTypes = {
        contentData: PropTypes.object,
        uid: PropTypes.string,
        wxLaunch: PropTypes.object,
        isHitBlack: PropTypes.bool,
        relatedRecommend: PropTypes.array,
        isCloseAlgRec: PropTypes.bool,
        ad: PropTypes.object,
        recommendVideoTwoPic1Ad: PropTypes.object,
    };

    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            pageSize: 11,
            twiceShareRecShow: false,
            bottomSlidesData: [],
            recVideos: [],
        };

        this.browser = typeof window === 'undefined' ? '' : Bowser.getParser(window.navigator.userAgent);
        this.browserInfo = typeof window === 'undefined' ? '' : this.browser.getOS();
        this.os = this.browserInfo.name || '';
        this.uid = this.props.uid;
        this.newsIds = [];
    }

    filterSameObj = (array) => {
        const filterArr = [];

        array.forEach((element) => {
            if (element && element.id) {
                if (this.newsIds.indexOf(element.id) < 0) {
                    this.newsIds.push(element.id);
                    filterArr.push(element);
                }
            }
        });

        return filterArr;
    };

    formatRelateData = (data) => {
        let result = [];

        if (!data || data.length === 0) {
            return result;
        }
        result = data.map((item) => {
            return {
                base62Id: item.base62Id || (item.commentsUrl && item.commentsUrl.replace('ucms_', '')),
                title: item.title,
                type: 'video',
                duration: Number(item.duration) || (item.phvideo && item.phvideo.length && Number(item.phvideo.length)),
                length: Number(item.duration) || (item.phvideo && item.phvideo.length && Number(item.phvideo.length)),
                newstype: 'video',
                thumbnail:
                    (item.thumbnails &&
                        item.thumbnails.image &&
                        item.thumbnails.image[0] &&
                        item.thumbnails.image[0].url) ||
                    item.thumbnail ||
                    item.posterUrl ||
                    '',
            };
        });

        return result;
    };

    arrayPropertyUnique = (arr = [], uniId = '') => {
        const obj = {};
        const tempArr = [];

        for (let i = 0; i < arr.length; i++) {
            if (!obj[arr[i][uniId]]) {
                tempArr.push(arr[i]);
                if (arr[i][uniId]) {
                    obj[arr[i][uniId]] = true;
                }
            }
        }

        return tempArr;
    };

    async componentDidMount() {
        const {
            contentData: {
                videoInfo: { title, guid },
                docData: { base62Id },
                isVideoShare,
            },
            wxLaunch,
            isHitBlack,
            relatedRecommend = [],
            isCloseAlgRec,
        } = this.props;
        // const recVideosData = await getNewsAppVideoRec(title, guid);
        let relatedData = [];
        let recVideosData = await getSpecificList(base62Id, 'share_relate_recom_video', 4);

        if (recVideosData && recVideosData.length > 0) {
            recVideosData = recVideosData.slice(0, 4);
        }
        if (relatedRecommend.length > 0) {
            relatedData = await getRelateFeedList(relatedRecommend);
        }
        // 命中（习近平&&新时代）黑名单并且没有ucms相关推荐
        if (isHitBlack || isCloseAlgRec) {
            recVideosData = [...relatedData];
        } else {
            recVideosData = [...relatedData, ...recVideosData];
        }

        recVideosData = this.formatRelateData(recVideosData);
        recVideosData = this.arrayPropertyUnique(recVideosData, 'base62Id');

        if (isHitBlack && relatedData.length === 0) {
            recVideosData = [];
        }

        if (recVideosData && recVideosData.length > 0) {
            const recVideos = recVideosData.map((item) => {
                item._id = (item?.link?.weburl && getUrlSecretId(item?.link?.weburl)) || item.base62Id || '';
                item.newstype = item.type;
                item.callUp = 1;
                item.kind = 'share52206';
                item.downloads = isVideoShare
                    ? {}
                    : {
                          download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1453822750895',
                          downloadAd:
                              'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8799',
                      };
                item.clickCount = {
                    behavior: 'action',
                    type: 'click',
                    other: {
                        to: item.id || `ucms_${item.base62Id}`,
                        ref: base62Id ? `ucms_${base62Id}` : guid,
                        rnum: '0',
                        tag: 't6',
                        kind: item.type === 'doc' ? 'article' : item.type,
                        url: encodeURIComponent(location.href),
                    },
                };
                item.allcount = 0;
                item.isVideoShare = !!isVideoShare;
                item.twoimage = 1;
                item.wxLaunchType = wxLaunch.wxLaunchType;
                item.wxLaunchSwitch = wxLaunch.wxLaunchSwitch;

                return item;
            });

            const twoimageVideos = transformArr(recVideos, 2).map((item) => ({
                type: 'twoimage',
                data: item,
            }));

            this.setState({
                recVideos: twoimageVideos,
            });
        }
    }

    render() {
        const {
            contentData: { bigPicSwiperData, isVideoShare, unfoldType, _id },
            contentData,
            ad,
            isHitBlack,
            recommendVideoTwoPic1Ad,
        } = this.props;

        let { recVideos } = this.state;
        const wxLaunch = (unfoldType && unfoldType.wxLaunch) || {};
        const wxLaunchConfig = {
            wxLaunchType: wxLaunch.wxLaunchType === '1' ? 'app' : 'weapp',
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch === '1',
        };
        const commentConfig = {
            type: 'video',
            _id,
            base62Id: contentData.docData.base62Id,
            skey: contentData.skey,
            pcUrl: contentData.pcUrl,
            isVideoShare,
        };

        return (
            <div className={styles.container}>
                {/* {!isHitBlack && <HotThemeList content={{ base62Id: contentData.docData.base62Id }} />} */}
                <RecVideos
                    content={recVideos}
                    bigPicSwiperData={bigPicSwiperData}
                    ad={ad}
                    recommendVideoTwoPic1Ad={recommendVideoTwoPic1Ad}
                />
                <HotComment content={commentConfig} wxLaunch={wxLaunchConfig} />
            </div>
        );
    }
}

export default errorBoundary(Content);
